export default {
    historyCount : 0,
}